export const consents = {
    state: {
        status: 'idle',
        consents: null,
        userConsents: null
    },
    mutations: {
        SET_CONSENTS_STATUS(state, payload) {
            state.status = payload
        },
        SET_CONSENTS(state, payload) {
            state.consents = payload.map(el => {
                return {
                    ...el,
                    isAdditionalConsent:
                        el.dict_consents.code === 'directMarketingSms' ||
                        el.dict_consents.code === 'directMarketingECSPSms'
                }
            })
        },
        SET_USER_CONSENTS(state, payload) {
            state.user_consents = payload
        }
    },
    actions: {
        consentsFetch({ state, commit, getters }) {
            if (state.status === 'idle') {
                commit('SET_CONSENTS_STATUS', 'loading')
                return this.$api
                    .get(`getAgreements/${getters.userId}`, {
                        params: {
                            all_consents: true,
                            included: 'DICT_CONSENTS'
                        }
                    })
                    .then(response => {
                        commit('SET_CONSENTS', response.data.data)
                    })
                    .catch(error => {
                        console.log(error)
                    })
                    .finally(() => {
                        commit('SET_CONSENTS_STATUS', 'idle')
                    })
            }
        },

        setConsentState({ state }, payload) {
            const consents = state.consents
            const findConsent = consents.find(
                el => +el.consent_id === +payload.id
            )
            if (findConsent) findConsent.state = payload.state
        },
        setConsentParams({ state }, payload) {
            const consents = state.consents
            const findConsent = consents.find(
                el => +el.consent_id === +payload.id
            )
            if (findConsent) findConsent.dict_consents.params = payload.param
        },
        saveUserConsent({ state, dispatch, commit, getters }, payload) {
            const consents = state.consents
            const consent = consents.find(
                el => el.consent_id === payload.consentId
            )
            const consentState = payload.value ? 'Y' : 'N'
            consent.state = consentState
            return this.$api
                .post(
                    `saveAgreement/${getters.userId}/consents/${consent.consent_id}/state/${consentState}`
                )
                .then(() => {
                    commit('SET_CONSENTS', consents)
                })
                .catch(err => {
                    console.log(err)
                })
        },
        saveMarketingConsents({ dispatch, getters }, payload) {
            const consents = payload.consentCode === 'ECSP'
                ? getters.getMarketingECSPConsents
                : getters.getMarketingConsents
            const params = consents.map(el => {
                let param = {
                    state: el.state,
                    source: el.source,
                    user_id: el.user_id,
                    consent_id: el.consent_id
                }
                if (el.dict_consents.params?.length) {
                    param = {
                        ...param,
                        params: el.dict_consents.params.map(param => {
                            return {
                                tag: param.tag,
                                value: param.value
                            }
                        })
                    }
                }
                return param
            })
            dispatch('saveUserConsents', params)
        },
        async saveServiceLoginConsent({ dispatch, getters, commit }, payload) {
            const allConsents = getters.getConsents
            const {
                source,
                user_id: userId,
                consent_id: consentId
            } = getters.getServiceLoginConsent

            const tmp = {
                source,
                user_id: userId,
                consent_id: consentId,
                state: payload.state
            }

            if (payload.state === 'Y') {
                Object.assign(tmp, {
                    service_login_status: payload.service_login_status
                })
            }

            const res = await dispatch('saveUserConsents', [tmp])

            if (res.status === 200) {
                const serviceConsent = allConsents.find(
                    consent => consent.dict_consents.code === 'serviceLogin'
                )

                serviceConsent.state = payload.state
                serviceConsent.value = payload.service_login_status

                commit('SET_CONSENTS', allConsents)
            }
        },
        async saveUserConsents({ state, dispatch, getters }, payload) {
            const res = await this.$api.post(
                `manyAgreements/${getters.userId}`,
                { user_consents: payload }
            )

            if (res.status !== 200) {
                dispatch('addNotification', {
                    type: 'danger',
                    content: 'Wystąpił błąd. Spróbuj ponownie później.'
                })
                throw res
            }

            return res
        }
    },
    getters: {
        getConsents: state => {
            if (state.consents) {
                return state.consents
            }
        },
        getConsentById: state => consentId => {
            if (state.consents) {
                const foundConsent = state.consents.find(
                    el => el.consent_id === consentId
                )
                if (foundConsent) return foundConsent.state === 'Y'
                return false
            }
        },
        getMarketingConsents: state => {
            return state.consents.filter(
                consent =>
                    consent.dict_consents.code === 'tradeInformation' ||
                    consent.dict_consents.code === 'directMarketing' ||
                    consent.dict_consents.code === 'directMarketingSms'
            )
        },
        getMarketingECSPConsents: (state, getters) => {
            const availableMerchants = getters.getAvailableMerchants

            // Skip ECSP consents if all available merchants belong to the GAMA network
            const allMerchantsInGama = availableMerchants?.length &&
                availableMerchants.every(merchant => merchant.network?.name?.toLowerCase() === 'gama')

            if (allMerchantsInGama) {
                return
            }

            return state.consents.filter(
                consent =>
                    consent.dict_consents.code === 'tradeInformationECSP' ||
                    consent.dict_consents.code === 'directMarketingECSP' ||
                    consent.dict_consents.code === 'directMarketingECSPSms'
            )
        },
        getServiceLoginConsent: state => {
            return state.consents.filter(
                consent => consent.dict_consents.code === 'serviceLogin'
            )[0]
        },
        getMarketingDetails: () => consentCode => {
            return consentCode === 'ECSP'
                ? {
                    consentCode: 'ECSP',
                    title: 'Zgody telekomunikacyjne Eurocash Sieci Partnerskie Sp. z o.o.',
                    consentDetails: 'Zaznaczenie poniższych zgód oznacza, że będziesz na bieżąco najnowszymi ofertami handlowymi Eurocash Sieci Partnerskie Sp. z o.o.. Pamiętaj,  że Twoja zgoda jest niezbędna z uwagi na aktualnie obowiązujące przepisy, w tym ustawę o prawie komunikacji elektronicznej. Zgodę możesz w każdej chwili wycofać, klikając w odpowiednie pole.',
                    requiredSave: true
                }
                : {
                    consentCode: 'EP',
                    title: 'Zgody telekomunikacyjne na EuroPlatform',
                    consentDetails: 'Zaznaczenie poniższych zgód oznacza, że będziesz na bieżąco z naszymi najnowszymi ofertami handlowymi. Pamiętaj, że Twoja zgoda jest niezbędna z uwagi na aktualnie obowiązujące przepisy, w tym ustawę o prawie komunikacji elektronicznej. Zgodę możesz w każdej chwili wycofać, klikając w odpowiednie pole.'
                }
        }
    }
}
